//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
import { PojoSet } from 'pojo-sets';
import { createSelector } from 'reselect';

import { getAllAlphabetizedGalleries } from '@galleries/selectors/getAllAlphabetizedGalleries';
import { ICuralateStore } from '@models/AppState';

export const getSelectedGalleries = createSelector(
  (state: ICuralateStore) => state.uiaModal.approveForGalleries.gallerySelection,
  getAllAlphabetizedGalleries,
  (selectedReelIds, allGalleries) => {
    return PojoSet.toArray(selectedReelIds).map((reelId) => {
      return allGalleries.find((gallery) => gallery.reelId === reelId);
    });
  }
);
